// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3R8R9","image":"Header_image__3cPBW","name":"Header_name__1xPOF","info":"Header_info__1fLRk","infoRow":"Header_infoRow__10tS3"};